import React from 'react';
import { TextField } from '@mui/material';

interface CarveOutFormFieldsProps {
    code: string;
    description: string;
    codeError?: string;
    descriptionError?: string;
    onCodeChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
}

export const CarveOutFormFields: React.FC<CarveOutFormFieldsProps> = ({
    code,
    description,
    codeError,
    descriptionError,
    onCodeChange,
    onDescriptionChange
}) => {
    return (
        <>
            <TextField
                label="Code"
                value={code}
                onChange={(e) => onCodeChange(e.target.value)}
                error={!!codeError}
                helperText={codeError}
                size="small"
                fullWidth
            />

            <TextField
                label="Description"
                value={description}
                onChange={(e) => onDescriptionChange(e.target.value)}
                error={!!descriptionError}
                helperText={descriptionError}
                fullWidth
                size="small"
                multiline
                rows={2}
            />
        </>
    );
};
